<template>
  <section> 
    <b-row>
      <b-col>
        <b-card
          style="max-width: 100%">
          <template v-slot:header >
            <div class="header-card text-left">
              Lista de Incapacidades  
              <b-button size="sm" @click="nuevoModal()" variant="outline-primary" style="float:right"> Nueva Incapacidad</b-button>
            </div>          
          </template>
            <b-row>
              <b-col :md="12" style="margin-top:10px">
                  <sw-tableget
                    :tableItems="tableGBItems"
                    :tableSearch="tableGBSearch"
                    :tableOptions="tableGBoptions"
                    name="tableGet"
                    route="get_incapacidades"
                    dataRoute="usuarios"
                    :filterShow="false"
                    @filtrar="getFiltrar"
                    >
                    <template v-slot:modal>                                        
                      <sw-modalegresos 
                        v-if="openModal.modal.modal==='Egresos'"
                        @save="saveForm">
                      </sw-modalegresos>
                      <sw-modalincapacidades 
                        v-if="openModal.modal.modal==='Editar'"
                        @save="saveForm"                     
                        >
                      </sw-modalincapacidades>                  
                      <sw-modalanularincapacidad
                        v-if="openModal.modal.modal==='Eliminar'"
                        @save="saveForm"
                        >
                      </sw-modalanularincapacidad>  
                    </template>
                  </sw-tableget>                  
              </b-col>              
            </b-row>            
        </b-card>
      </b-col>
    </b-row> 
     <b-modal 
          v-if="openModal.modal.modal==='Nuevo'"
          v-model="openModal.modal.value"
          :title="openModal.modal.title" 
          :header-bg-variant="'primary'"
          header-text-variant="light"
          :hide-footer="true"  
          :no-close-on-backdrop="true" 
          size="lg"  
          >        
            <sw-modalincapacidades 
              @save="saveForm"                     
              >
            </sw-modalincapacidades>      
        </b-modal>                   
  </section>
</template>

<script>
import indexMix  from './indexMix.js'
import storeMix  from './storeMix.js'
import tableMix  from './tableMix.js'
import saveMix  from './saveMix.js'
import saveMixins  from '@/mixings/save.js'
import SwInputs from '@/components/forms/inputs.vue'
import SwSaveform from '@/components/forms/saveForm.vue'
import SwTableget from '@/components/dataTable/tableGet.vue'
import SwModalanularincapacidad from '@/components/modals/anularIncapacidad.vue'
import SwModalincapacidades from '@/components/modals/incapacidades.vue'
import SwModalegresos from '@/components/modals/egresos.vue'

export default { 
  name: "datos_pacientes",
  mixins: [indexMix,storeMix,tableMix,saveMix,saveMixins,],
  components: {
  SwInputs,
  SwSaveform,
  SwTableget,
  SwModalanularincapacidad,
  SwModalincapacidades,
  SwModalegresos
     
  }
}
</script>
<style>
.nav-tabs .nav-link.active, .nav-tabs .nav-item.show .nav-link
{
  background: #fcfcfc;
  font-weight: 500;
}
</style>

